import { Component, OnInit, Inject, Input } from '@angular/core';
import { faTimes} from '@fortawesome/pro-light-svg-icons';
import { PreexchangeChecklistService } from 'src/app/shared/services/preexchange-checklist.service';
import { LettersService } from 'src/app/shared/services/letters.service';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-preexchange-checklist',
  templateUrl: './preexchange-checklist.component.html',
  styleUrls: ['./preexchange-checklist.component.scss']
})
export class PreexchangeChecklistComponent implements OnInit {

  @Input() caseId: number = -1;

  faTimes = faTimes;

  generatingPDF: boolean = false;
  error: boolean = false;
  errorMessage: string = "";

  items: any [] = [];

  constructor(
    public preexchangeChecklistService: PreexchangeChecklistService,
    public lettersService: LettersService,
    public activeModal: NgbActiveModal,
    private correspondenceTimelineService: CorrespondenceTimelineService) {

    }

  ngOnInit(): void {

       this.preexchangeChecklistService.getChecklistItemsForCase(this.caseId).subscribe((response : any) => {
          this.items = response.items;

        }, (error: any) => {

          this.error = true;
          if(error.status == 999)
          this.errorMessage = error.error;
        else if(error.status == 500 )
          this.errorMessage = "Internal Error";
        else
          this.errorMessage = error.statusText;
      });
  }

  generatePDF(){
    this.lettersService.generatePreExchangeChecklist(this.caseId).subscribe((response : any) => {
      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    }, (error: any) => {
      this.error = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;
    });  
  }

  updateValue(item: any){

    this.preexchangeChecklistService.updateItem(this.caseId, item.id, item.checklistResponseType).subscribe((response : any) => {

      this.items.forEach((i : any) => {

        if(response.id == i.id)
        {
          i.byUser = response.byUser;
          i.dateEntered = response.dateEntered;
        }
      });


    }, (error: any) => {

      this.error = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;
    });
  }

  updateCommentary(item: any){

    this.preexchangeChecklistService.updateCommentary(this.caseId, item.id, item.commentary).subscribe((response : any) => {


    }, (error: any) => {

      this.error = true;
      if(error.status == 999)
        this.errorMessage = error.error;
      else if(error.status == 500 )
        this.errorMessage = "Internal Error";
      else
        this.errorMessage = error.statusText;
    });
  }

  clearValue(item: any){
    item.checklistResponseType = null;
    this.updateValue(item);
  }

}
